/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useStateValue } from "./StateProvider";
import { getBookmark, removeFromBookmark } from "../functions/user";
import Button from "@material-ui/core/Button";

function Bookmark() {
  const divStyle = {
    marginTop: "10px",
  };
  const [{ bookmark }, dispatch] = useStateValue();
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    gettingBookmarkedCanteens();
  }, []);

  const gettingBookmarkedCanteens = () => {
    getBookmark(user.token).then((res) => {
      dispatch({
        type: "GET_BOOKMARK",
        bookmark: res.data.bookmark,
      });
    });
  };

  const handleRemoveFromBookmark = (e, formId) => {
    e.preventDefault();

    removeFromBookmark(user.token, formId).then(() =>
      gettingBookmarkedCanteens()
    );
  };

  return (
    <div class="wrapper">
      <h1 class="heading">Bookmarked Canteens</h1>
      <div class="cols">
        {bookmark.length === 0 ? (
          <div>
            <div class="front pic">
              <div class="innerr">
                <p>No Bookmarked Canteens Available</p>
              </div>
            </div>
          </div>
        ) : (
          bookmark.map((details) => (
            <>
              <div class="col" ontouchstart="this.classList.toggle('hover');">
                <div class="containerSearch">
                  <div class="front pic">
                    <div class="innerr">
                      <p>{details.name}</p>
                      <span>📍{details.state} Maharashtra</span> <br></br>
                      <span>Cost: {details.price}</span>
                    </div>
                  </div>

                  <div class="back">
                    <div class="innerr">
                      <p>📞Contact Me:</p>
                      <p>{details.phoneNumber}</p>
                      <Button
                        href={details.canteenLink}
                        target="_blank"
                        variant="contained"
                      >
                        {" "}
                        <b>Visit Canteen Link </b>
                      </Button>
                    </div>
                  </div>
                </div>
                <Button
                  style={divStyle}
                  onClick={(e) => handleRemoveFromBookmark(e, details._id)}
                  variant="contained"
                >
                  {" "}
                  <b>Remove</b>
                </Button>
              </div>
            </>
          ))
        )}
      </div>
    </div>
  );
}

export default Bookmark;
